// These styles go into the head of the **host** page unlike other styles
// that are also defined in Widget.tsx which go into the *shadow dom*.

const InjectedStyles = ({ zIndex = 999 }) => `
.rough-annotation {z-index: ${zIndex};};
`;

export default InjectedStyles;
